<script setup lang="ts">
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";
import { IconGlobeThin } from "@packages/icon-library";
import { useI18n } from "vue-i18n";
import Translate from "@/i18n/translate";

const { t } = useI18n();
const showLangDropDown = ref(false);
const target = ref<any>(null);
const { locale } = useI18n();
const supportedLocales = Translate.supportedSystemLocales;

const changeLanguage = (locale: string) => {
  Translate.switchLanguage(locale);
  showLangDropDown.value = false;
  window.location.reload();
};

onClickOutside(target, () => {
  showLangDropDown.value = false;
});
</script>

<template>
  <div ref="target" class="lang-selector">
    <button
      type="button"
      class="header-item"
      @click="showLangDropDown = !showLangDropDown"
    >
      <IconGlobeThin /> {{ locale }}
    </button>

    <div v-if="showLangDropDown" class="lang-selector__drop-down">
      <button
        v-for="(language, index) in supportedLocales"
        :key="index"
        type="button"
        @click="changeLanguage(language)"
      >
        {{ t(`locales.${language}`) }}
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.lang-selector {
  position: relative;

  > button {
    text-transform: uppercase;
  }

  &__drop-down {
    position: absolute;
    width: 256px;
    left: 0;
    top: calc(100% + 8px);
    padding: ($base-space * 2) 0;
    border-radius: 8px;
    background-color: var(--color-semantic-background-normal-bg-primary);
    box-shadow: 0 0 30px 0 rgba(169, 169, 169, 0.15);
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    z-index: 5;

    > button {
      width: 100%;
      padding: ($base-space * 2) ($base-space * 4);
      @include body-m();
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: $base-space * 2;
      color: var(--color-semantic-content-normal-primary);

      @media (hover: hover) {
        &:hover {
          background-color: var(--color-semantic-background-hover-primary);
        }
      }
    }
  }
}
</style>
